import * as _ from 'lodash';
import * as Highcharts from "highcharts";

const additionalColors = ['#8b0707', '#dc3912', '#6633cc', '#0099c6', '#994499'];

export const CHART_COLORS = _.clone(Highcharts.getOptions().colors)
  .concat(additionalColors).concat(Highcharts.getOptions().colors).concat(additionalColors);